var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckboxChecked = function SvgIconCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "#212121",
    stroke: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.17 6.319a1.06 1.06 0 0 1 1.514-.002 1.09 1.09 0 0 1 0 1.534l-.002.002-9.708 9.825-.002.002c-.417.427-1.1.427-1.516 0l-5.14-5.202h-.002a1.092 1.092 0 0 1 0-1.534 1.059 1.059 0 0 1 1.515 0l.001.001 4.384 4.437 8.955-9.062v-.001Z",
    fill: "#fff"
  })));
};
export default SvgIconCheckboxChecked;